import React, { useState, useRef, useEffect } from 'react';
import './CustomDropdown.css';
import { IoChevronDown } from 'react-icons/io5';

const CustomDropdown = ({ options, value, onChange, placeholder, label }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggle = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Determine display text
  const getDisplayText = () => {
    if (!value) return placeholder || 'Select';
    // If options are objects with label/value, handle that (future proofing), 
    // but for now assuming strings based on usage.
    return value;
  };

  return (
    <div className="custom-dropdown-container" ref={dropdownRef}>
      {label && <label className="custom-dropdown-label">{label}</label>}
      
      <div className={`custom-dropdown-header ${isOpen ? 'open' : ''}`} onClick={handleToggle}>
        <span className={`custom-dropdown-selected ${!value ? 'placeholder' : ''}`}>
          {getDisplayText()}
        </span>
        <IoChevronDown className={`custom-dropdown-arrow ${isOpen ? 'open' : ''}`} />
      </div>

      {isOpen && (
        <div className="custom-dropdown-list">
          {options.map((option, index) => (
            <div 
              key={index} 
              className={`custom-dropdown-option ${value === option ? 'selected' : ''}`}
              onClick={() => handleOptionClick(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
